import {Injectable} from '@angular/core';
import {SessionStorageService} from 'ngx-webstorage';
import {Observable} from 'rxjs/Observable';
import {ShoppingCart} from '../../common/model/shopping-cart/shopping-cart.model';
import {Reservation} from '../model/reservation/reservation.model';
import {LogService} from './logging.service';
import {useDefault} from '../../common/common';
import {CartItemType} from '../../common/model/shopping-cart/cart-item-type.model';
import {ReservationCartItem} from '../../common/model/shopping-cart/reservation-item.model';
import {DateUtils} from '../../common/date.utils';
const SHOPPING_CART_KEY = 'shoppingCart';
@Injectable()
export class ShoppingCartService {
  constructor(private sessionStorage: SessionStorageService,
              private _log: LogService) {}

  public getCart (): Observable<ShoppingCart> {
    const cartData = useDefault(this.sessionStorage.retrieve(SHOPPING_CART_KEY), {});
    return Observable.of(this.toShoppingCart(cartData));
  }
  public updateCart (cart: ShoppingCart): void {
    this.sessionStorage.store(SHOPPING_CART_KEY, cart);
  }

  public clearCart (): void {
    this.sessionStorage.clear(SHOPPING_CART_KEY);
  }

  public addReservationInCart (reservation: Reservation): void {
    this.getCart().subscribe((shoppingCart: ShoppingCart) => {
      const existingItemIndex: number =  this.findReservationItemIndexInCart(shoppingCart, reservation);
      if (existingItemIndex !== -1 ) {
        shoppingCart.items.splice(existingItemIndex, 1);
      }
      shoppingCart.items.push(this.toReservationData(reservation));
      this.updateCart(shoppingCart);
    });
  }

  public getReservationItemFromCart(reservation: Reservation): Observable<ReservationCartItem> {
    return this.getCart().map((shoppingCart: ShoppingCart) => {
      const existingItemIndex: number =  this.findReservationItemIndexInCart(shoppingCart, reservation);
      if (existingItemIndex === -1 ) {
        throw new Error('Reservation not found in cart');
      }
      return shoppingCart.items[existingItemIndex] as ReservationCartItem;
    });
  }

  private findReservationItemIndexInCart(shoppingCart: ShoppingCart, reservation: Reservation): number {
    return shoppingCart.items.findIndex(element => {
      if (element instanceof ReservationCartItem) {
        return element.reservationId === reservation.confirmationNumber;
      }
      return false;
    });
  }

  private toShoppingCart (shoppingData: any): ShoppingCart {
    const shoppingCart: ShoppingCart =  new ShoppingCart();
    shoppingCart.items = [];
    for (const itemData of useDefault(shoppingData.items, [])) {
      if (itemData.itemType === CartItemType.RESERVATION) {
        shoppingCart.items.push(this.toReservationCartItem(itemData));
      }
    }
    return shoppingCart;
  }
  private toReservationCartItem(itemData: any): ReservationCartItem {
    const reservationItem: ReservationCartItem = new ReservationCartItem();
    reservationItem.creationTime = useDefault(itemData.creationTime, new Date().getTime())
    reservationItem.itemType = CartItemType.RESERVATION;
    reservationItem.reservationId = useDefault(itemData.reservationId, null);
    reservationItem.hotelId = useDefault(itemData.hotelId, null);
    reservationItem.roomCode = useDefault(itemData.roomCode, null);
    reservationItem.rateCode = useDefault(itemData.rateCode, null);
    reservationItem.freeNightId =  useDefault(itemData.freeNightId, null);
    reservationItem.pointsAndCashId = useDefault(itemData.pointsAndCashId, null);
    reservationItem.numAdults = Number(useDefault(itemData.numAdults, 0));
    reservationItem.numChildren = Number(useDefault(itemData.numChildren, 0));
    reservationItem.corpId = useDefault(itemData.corpId, null);
    reservationItem.groupCode = useDefault(itemData.groupCode, null);
    reservationItem.iataNumber = useDefault(itemData.iataNumber, null);
    reservationItem.numRooms = Number(useDefault(itemData.numRooms, 0));
    reservationItem.checkinDate =  DateUtils.fromUSLocaleDateToDate(itemData.checkinDate);
    reservationItem.checkoutDate = DateUtils.fromUSLocaleDateToDate(itemData.checkoutDate);
    reservationItem.selectedCurrency = useDefault(itemData.selectedCurrency, null);
    return reservationItem;
  }
  private toReservationData(reservation: Reservation): any {
    const data: any = {};
    data.creationTime =  new Date().getTime();
    data.itemType = CartItemType.RESERVATION;
    data.reservationId = reservation.confirmationNumber;
    data.hotelId = reservation.hotelMnemonic;
    data.roomCode = reservation.room.code;
    data.rateCode = reservation.rate.code;
    data.numAdults = String(reservation.stay.numberOfAdults);
    data.numChildren = String(reservation.stay.numberOfChildren);
    data.numRooms = String(reservation.stay.numberOfRooms);
    data.checkinDate =  DateUtils.toShortDateUSLocale(reservation.stay.checkInDate);
    data.checkoutDate = DateUtils.toShortDateUSLocale(reservation.stay.checkOutDate);
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/shopping-cart.service.ts